import React, { useState, useEffect } from "react";
import { Grid, Container, Box } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import {
  CustomLabel,
  CustomTitle,
} from "../../components/Custom/CustomTypography";
import SearchComponent from "../../components/Custom/CustomSearch";
import ListGenericCard from "../../components/Custom/ListGenericCard";
import { useNavigate } from "react-router-dom";

export default function ProspectBorrowers() {
  const navigate = useNavigate();
  const [fpos, setFPOs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [unlockedFposCount, setUnlockedFposCount] = useState(0);
  const { t } = useTranslation();

  const fetchFpoList = async (searchQuery) => {
    try {
      const params = { search: searchQuery };
      const response = await api.get("/lending/get-fpo-list", {
        params: params,
      });
      setFPOs(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Borrower list:", error);
      setLoading(false);
    }
  };

  const fetchUnlockedFposCount = async () => {
    try {
      const response = await api.get(
        `/lending/unlock_fpo/get_unlocked_fpos_count`
      );
      setUnlockedFposCount(response.data.count);
    } catch (error) {
      console.log("Error fetching unlocked FPOs count:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    setSearchQuery(value);
  };

  useEffect(() => {
    fetchFpoList(searchQuery);
  }, [searchQuery]);

  useEffect(() => {
    fetchUnlockedFposCount();
  }, []);

  const handleCardClick = (userId) => {
    navigate(`/lender/send-loan-proposal/${userId}`);
  };
  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container maxWidth="xs">
          <CustomTitle>{t("Prospects")}</CustomTitle>

          <Box sx={{ marginTop: "15px" }}>
            <CustomLabel>
              {t(`Total FPOs Unlocked : ${unlockedFposCount}`)}
            </CustomLabel>
          </Box>

          <Grid container>
            <SearchComponent
              onSearch={handleSearch}
              t={t}
              roundIcon
              placeholder={t("Search by FPO name")}
            />
          </Grid>

          {fpos.map((proposal) => (
            <>
              <ListGenericCard
                key={proposal.id}
                title={`${
                  proposal?.fpo_details?.name
                    ? proposal?.fpo_details?.name
                    : proposal.name
                } `}
                loanProposals={proposal.loan_proposals}
                onClick={() => handleCardClick(proposal?.id)}
              />
            </>
          ))}
        </Container>
      </LoaderContainer>
    </>
  );
}
